import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

export const purchaseBySupplierProductReportFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "status",
    label: "Estado del Documento",
    type: "select",
    iconKey: "status",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
